/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_cloud_logic_custom": [
        {
            "name": "neural",
            "endpoint": "https://mga85e8qod.execute-api.us-east-1.amazonaws.com/dev",
            "region": "us-east-1"
        }
    ],
    "aws_appsync_graphqlEndpoint": "https://dsbxscqvyzh55fowdphoyouzra.appsync-api.us-east-1.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-1",
    "aws_appsync_authenticationType": "API_KEY",
    "aws_appsync_apiKey": "da2-hz25a6dgzvfbvpkw3jhy5lk42y",
    "aws_cognito_identity_pool_id": "us-east-1:bb28bed2-9242-41d1-bbeb-0842a2dae12b",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_9Ix1dDWfq",
    "aws_user_pools_web_client_id": "3e1kfvfufk6d0186k834b1h2c7",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_dynamodb_all_tables_region": "us-east-1",
    "aws_dynamodb_table_schemas": [
        {
            "tableName": "Plan-cbkye5ofsbeijc6yr4lwxmqewq-snapspace",
            "region": "us-east-1"
        },
        {
            "tableName": "contact-dev",
            "region": "us-east-1"
        }
    ],
    "aws_user_files_s3_bucket": "neuralstorage111827-dev",
    "aws_user_files_s3_bucket_region": "us-east-1"
};


export default awsmobile;
